import { useHistory } from "react-router-dom"
import { useIntl } from 'react-intl'
import React, { useState } from 'react'
import { ToastContainer, toast } from 'react-toastify';
import { TablesCodeBookBba } from "./TablesCodeBookBba";
import { RootState } from '../../../setup';
import { shallowEqual, useSelector } from 'react-redux'
import { UserModel } from '../auth/models/UserModel'
import { apiUrl as host } from '../../../setup/appConfig'
import { authFetch } from '../auth/redux/AuthFetch'

type Props = {
  className: string
}

export interface IState {
  idParam: number;
  codeBookHostparam?: string;
  longNameCodeBookParam: string;
  shortNameCodeBookParam: string;
  addressParam: string;
  allowParam: boolean;
}
export interface CodeBook {
  id: number;
  longNameCodeBook: string;
  shortNameCodeBook: string;
  address: string;
  username: string;
  lastDateModified: string;
}
class CodeBookClass {

  ShortNameCodeBook: string;
  LongNameCodeBook: string;
  Address: string;
  constructor(LongNameCodeBook: string, ShortNameCodeBook: string, Address: string) {
    this.LongNameCodeBook = LongNameCodeBook;
    this.ShortNameCodeBook = ShortNameCodeBook;
    this.Address = Address;
  }

}

const CodeBookBbaEdit: React.FC<Props> = ({ className }): any => {

  const history = useHistory();
  const stateparams = (history.location.state) as IState
  let x = stateparams ? stateparams.longNameCodeBookParam.toString() : '';
  let y = stateparams ? stateparams.shortNameCodeBookParam.toString() : '';
  let z = stateparams ? stateparams.addressParam.toString() : '';
  let w = stateparams ? stateparams.idParam as number : 0;
  const accessToken: any = useSelector<RootState>(({ auth }) => auth.accessToken, shallowEqual)
  const user: UserModel = useSelector<RootState>(({ auth }) => auth.user, shallowEqual) as UserModel

  const [LongName, setLongName] = useState(x)
  const [ShortName, setShortName] = useState(y);
  const [Address, setAddress] = useState(z);

  const [CodeArray, fillCodeBookArray] = useState<CodeBook[]>([])
  const intl = useIntl();

  const onKeyDownHandler = (e: any) => {
    if (e.keyCode === 13) {
      updateCodeBook(LongName, ShortName, Address);
    }
  };

  const onChangeLongName = (event: any) => {
    event.preventDefault();
    event.stopPropagation();
    setLongName(event.target.value);
  }


  const onChangeShortName = (event: any) => {
    event.preventDefault();
    event.stopPropagation();
    setShortName(event.target.value);

  }
  const onChangeAddress = (event: any) => {
    event.preventDefault();
    event.stopPropagation();
    setAddress(event.target.value);

  }




  const [showNoResultMessage, setShowNoResultMessage] = useState('');
  const resetInputField = () => {
    setLongName('');
    setShortName('');
    setAddress('');
  }

  function updateCodeBook(LongName: string, ShortName: string, Address: string) {

    const codeBookObject = {
      Id: w,
      LongNameCodeBook: LongName,
      ShortNameCodeBook: ShortName,
      Address: Address,
      Username: user.username,

    };

    if (LongName === '' || ShortName === '' || Address === '') {
      alert('Molimo vas upišite vrijednosti za filtere pretrage!')
    }
    else {
      const clientId: string = process.env.REACT_APP_CLIENT_ID || '6CAC6ED4-EDA2-4A30-BF01-29CD88E52F44'
      const requestoptions = {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
          ClientId: clientId,
          Authorization: accessToken,
        },

        // body: JSON.stringify(x.toString()),
        body: JSON.stringify(codeBookObject)
        //data
      }
      var endpoint = `${host}/inquiry/updateCodeBook`;

      authFetch(
        endpoint,
        requestoptions
      ).then(res => res.json())
        .then(response => {
          if (response != null) {
            alert('Uspješno ažuriran zapis u šifarniku');
          }
        })
        .catch(error => {
          toast('Greška: ', error.toString());
        });
    }
  }



  const editcodeBookView = () => {
    return <div className={`card ${className}`} >
      <div className='col-xxl-12' style={{ width: "132%", position: "relative", backgroundColor: "#cfe2f3", alignSelf: "center" }}>
        <div className='card-header align-items-center border-0 mt-4' style={{ width: "100%", position: "relative", backgroundColor: "#cfe2f3", alignSelf: "center" }}>

          <div className='input-group'>
            <div className='col-3 col-sm-3 col-lg-6' style={{ paddingBottom: "1%" }}>
              <div className='d-flex align-items-center position-relative my-1 mx-3'>
                <h3 className='card-title align-items-start flex-column' style={{ paddingLeft: "1%" }} >
                  <span className='fw-bolder mb-2 text-dark'>
                    {intl.formatMessage({ id: 'CODEBOOK.EDITTEXT' })}
                  </span>
                </h3>
              </div>
            </div>
            <div className='col-3 col-sm-3 col-lg-6' style={{ paddingBottom: "1%" }}>
              <div className='d-flex align-items-center position-relative my-1 mx-3'>
                <h3 className='card-title align-items-start flex-column'>
                  <span className='fw-bolder mb-2 text-dark'>
                    <div>

                    </div>
                  </span>
                </h3>
              </div>
            </div>
          </div>

          <div className='input-group'>
            <div className='col-3 col-sm-3 col-lg-6' style={{ paddingBottom: "1%" }}>
              <div className='d-flex align-items-center position-relative my-1 mx-3'>
                <input
                  value={LongName}
                  onChange={onChangeLongName}
                  onKeyDown={onKeyDownHandler}
                  type='text'
                  data-kt-customer-table-filter='search'
                  className='form-control form-control-solid ps-3'
                  placeholder={intl.formatMessage({ id: 'CODEBOOK.DUZINAZIV' })}
                  required
                  title="Unijeti duži naziv za šifarnik"
                />
              </div>
            </div>

            <div className='col-3 col-sm-3 col-lg-6' style={{ paddingBottom: "1%" }}>
              <div className='d-flex align-items-center position-relative my-1 mx-3'>
                <input
                  value={ShortName}
                  onChange={onChangeShortName}
                  onKeyDown={onKeyDownHandler}
                  type='text'
                  data-kt-customer-table-filter='search'
                  className='form-control form-control-solid ps-3'
                  placeholder={intl.formatMessage({ id: 'CODEBOOK.KRACINAZIV' })}
                  required
                  title="Unijeti kraći naziv za šifarnik"
                />
              </div>
            </div>

            <div className='col-3 col-sm-3 col-lg-6' style={{ paddingBottom: "1%" }}>
              <div className='d-flex align-items-center position-relative my-1 mx-3'>
                <input
                  value={Address}
                  onChange={onChangeAddress}
                  onKeyDown={onKeyDownHandler}
                  type='text'
                  data-kt-customer-table-filter='search'
                  className='form-control form-control-solid ps-3'
                  placeholder={intl.formatMessage({ id: 'CODEBOOK.ADRESA' })}
                  required
                  title="Unijeti adresu za šifarnik"
                />
              </div>
            </div>

          </div>


          <div className='input-group'>

            <div className='col-3 col-sm-3 col-lg-6' style={{ paddingBottom: "1%" }}>
              <div className='d-flex align-items-center position-relative my-1 mx-3'>
                <button
                  type='submit'
                  className='btn btn-secondary my-1'
                  onClick={() => history.push('/dashboard')} style={{ backgroundColor: "forestgreen", color: "beige", width: '100%', height: '100%' }}>
                  <svg id="add-zoom" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none">

                  </svg>

                  <span className="pl-5">
                    {intl.formatMessage({ id: 'CODEBOOK.BACK' })}
                  </span>
                </button>
              </div>
            </div>

            <div className='col-3 col-sm-3 col-lg-6' style={{ paddingBottom: "1%" }}>
              <div className='d-flex align-items-center position-relative my-1 mx-3'>
                <button
                  type='submit'
                  className='btn btn-secondary my-1'
                  onClick={() => updateCodeBook(LongName, ShortName, Address)}
                  style={{ backgroundColor: "#009EF7", color: "beige", width: '100%', height: '100%' }}>
                  <svg id="add-zoom" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none">
                  </svg>
                  <span className="pl-5">
                    {intl.formatMessage({ id: 'CODEBOOK.EDIT' })}
                  </span>
                </button>
              </div>
            </div>
          </div>


          <ToastContainer />







        </div>

      </div >
      {
        CodeArray.length > 0
          ?
          (
            < TablesCodeBookBba className='col-xxl-12' parentToChild={CodeArray} username={user.username} />
          )
          :
          null

      }



    </div >
  }
  return editcodeBookView();

}





export { CodeBookBbaEdit }


